// Definitions

(function() {

  if (typeof window.SITE === "undefined") {
    window.SITE = {};
  }

  SITE.parallaxScroll = function() {

    var controller = new ScrollMagic.Controller();
    var timeline1 = new TimelineMax()
      .from('#slide-text', 1, {opacity:'1'})
      .to('#slide-text', 1, {opacity: '0'});


      new ScrollMagic.Scene ({triggerElement:"#slider-parent", reverse:true, duration: '200%'})
          // .setPin('.page__header__slider',{pushFollowers: true})
          .setTween("#slide-text", {y: "110%", ease: Linear.easeNone})
          .addTo(controller);


    new ScrollMagic.Scene({triggerElement:"#slider-parent", reverse:true, duration: '100%'})
      .setTween(timeline1)
      .addTo(controller);

    
}

})();


// Invocations

$(function () {


  SITE.parallaxScroll();

});
